import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-2 d-sm-flex align-items-center justify-content-between letter-spacing d-print-none" }
const _hoisted_2 = { class: "fs-5 fw-bold" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb mb-0 list-unstyled ps-0" }
const _hoisted_5 = ["aria-current"]
const _hoisted_6 = { key: 1 }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadCrumb',
  props: {
    PageTitle: {},
    items: {}
  },
  setup(__props: any) {

const props = __props;

const breadcrumbItems = computed(() => {
  return props.items && props.items.length > 0
    ? props.items
    : [{ label: "Início", to: "/" }];
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.PageTitle), 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ol", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbItems.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: idx,
            class: _normalizeClass(["breadcrumb-item", { active: idx === breadcrumbItems.value.length - 1 }]),
            "aria-current": idx === breadcrumbItems.value.length - 1 ? 'page' : undefined
          }, [
            (item.to && idx !== breadcrumbItems.value.length - 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.to,
                  class: "text-decoration-none text-black"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.label), 1))
          ], 10, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})